import { render, staticRenderFns } from "./ManageCart.vue?vue&type=template&id=71cc046d&scoped=true&"
import script from "./ManageCart.vue?vue&type=script&lang=js&"
export * from "./ManageCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc046d",
  null
  
)

export default component.exports